// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1iJce","label":"Radio_label__2rahA","checkMark":"Radio_checkMark__3R6N5","disabled":"Radio_disabled__2ZNMv"};